module.exports = __webpack_public_path__ + "media/images/help/company/mv-company-02-1be24e3844b85927a98c6a98a60a1245.jpg";